// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "mg-mczx/static/css/" + chunkId + "." + {"216":"66771bfa","551":"1430f63b","750":"9911e61b"}[chunkId] + ".css";
};